<div [class]="class">
  <select #select [class.prefix]="!!prefixIcon" [class.suffix]="!!suffixIcon" (change)="onChange($event)" [attr.data-test]="testAttribute">
    <option *ngFor="let option of options" [value]="option.value" [selected]="data === option.value">
      {{ option.label }}
    </option>
  </select>
  <div>
    <lib-icon *ngIf="prefixIcon" [name]="prefixIcon"></lib-icon>
    <span class="lib-spacer" role="none"></span>
    <lib-icon *ngIf="suffixIcon" [name]="suffixIcon"></lib-icon>
  </div>
  <ng-content></ng-content>
</div>
